import { useEffect, useState } from "react";
import { Backdrop, Box } from "@mui/material";
import "./loading-ai.component.css";

const MENSAGENS_PADRAO = [
  "Analisando itens da nota",
  "Validando alíquotas",
  "Calculando valores",
  "Verificando impostos",
  "Processando dados fiscais",
];

const LoadingAi = ({ loading, mensagens }) => {
  const lista = mensagens?.length ? mensagens : MENSAGENS_PADRAO;
  const [indice, setIndice] = useState(0);
  const [fade, setFade] = useState(true);
  const [progress, setProgress] = useState(0);
  const [animateEntry, setAnimateEntry] = useState(false);

  useEffect(() => {
    let t;
    if (loading) {
      setAnimateEntry(false);
      t = setTimeout(() => setAnimateEntry(true), 8);
      const remove = setTimeout(() => setAnimateEntry(false), 420);
      return () => {
        clearTimeout(t);
        clearTimeout(remove);
      };
    } else {
      setAnimateEntry(false);
    }
  }, [loading]);

  useEffect(() => {
    if (!loading) {
      setIndice(0);
      setFade(true);
      setProgress(0);
      return;
    }
    const DURACAO = 2600;
    const intervalo = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndice((prev) => (prev + 1) % lista.length);
        setProgress(0);
        setFade(true);
      }, 450);
    }, DURACAO);
    const tick = 50;
    const progTimer = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 0 : prev + (tick / DURACAO) * 100));
    }, tick);
    return () => {
      clearInterval(intervalo);
      clearInterval(progTimer);
    };
  }, [loading, lista]);

  return (
    <Backdrop
      style={{
        zIndex: 2000,
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(6, 6, 18, 0.82)",
      }}
      open={loading}
    >
      <Box className={`loading-ai-root ${animateEntry ? "ai-entering" : ""}`}>
        <Box className="spark-wrapper">
          <Box className="glow" />
          <svg
            viewBox="0 0 40 40"
            className="spark-sat"
            style={{
              top: 4,
              left: 8,
              animationDelay: "0.6s",
              position: "absolute",
              width: 30,
              height: 30,
              filter: "drop-shadow(0 0 4px rgba(167,139,250,0.7))",
            }}
          >
            <path
              d="M20 2 C20 2 21.5 11 28 18 C21.5 25 20 34 20 34 C20 34 18.5 25 12 18 C18.5 11 20 2 20 2Z"
              fill="rgba(167,139,250,0.75)"
            />
          </svg>
          <svg
            viewBox="0 0 40 40"
            className="spark-sat small"
            style={{
              bottom: 2,
              right: 6,
              animationDelay: "1.3s",
              position: "absolute",
              width: 34,
              height: 34,
              filter: "drop-shadow(0 0 5px rgba(139,92,246,0.6))",
            }}
          >
            <path
              d="M20 2 C20 2 21.5 11 28 18 C21.5 25 20 34 20 34 C20 34 18.5 25 12 18 C18.5 11 20 2 20 2Z"
              fill="rgba(139,92,246,0.65)"
            />
          </svg>
          <svg
            viewBox="0 0 80 80"
            className="spark-main"
            style={{
              animationDelay: "0s",
              filter:
                "drop-shadow(0 0 14px rgba(255,255,255,0.5)) drop-shadow(0 0 30px rgba(167,139,250,0.8))",
            }}
          >
            <path
              d="M40 2 C40 2 43 22 58 40 C43 58 40 78 40 78 C40 78 37 58 22 40 C37 22 40 2 40 2Z"
              fill="white"
            />
          </svg>
        </Box>
        <Box style={{ textAlign: "center" }}>
          <p
            style={{
              margin: 0,
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "#818cf8",
              marginBottom: 10,
            }}
          >
            IA Processando
          </p>

          <Box sx={{ minHeight: 28 }}>
            <p
              key={indice}
              className="ai-msg-enter"
              style={{
                margin: 0,
                color: "#f1f5f9",
                fontSize: 17,
                fontWeight: 600,
                opacity: fade ? 1 : 0,
                transition: "opacity 0.45s ease",
                letterSpacing: "0.01em",
              }}
            >
              {lista[indice]}
              <span
                style={{
                  display: "inline-block",
                  marginLeft: 2,
                  animation: "ai-dot-bounce 1.4s ease-in-out infinite 0s",
                  color: "#a78bfa",
                }}
              >
                .
              </span>
              <span
                style={{
                  display: "inline-block",
                  animation: "ai-dot-bounce 1.4s ease-in-out infinite 0.2s",
                  color: "#a78bfa",
                }}
              >
                .
              </span>
              <span
                style={{
                  display: "inline-block",
                  animation: "ai-dot-bounce 1.4s ease-in-out infinite 0.4s",
                  color: "#a78bfa",
                }}
              >
                .
              </span>
            </p>
          </Box>
        </Box>

        <Box
          sx={{
            width: 300,
            height: 5,
            borderRadius: 999,
            background: "rgba(255,255,255,0.15)",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              height: "100%",
              width: `${progress}%`,
              borderRadius: 999,
              background:
                "linear-gradient(90deg, #6366f1, #a78bfa 50%, #e879f9 80%, #a78bfa)",
              backgroundSize: "200% auto",
              animation: "ai-bar-shimmer 1.8s linear infinite",
              boxShadow: "0 0 10px rgba(167,139,250,0.7)",
              transition: "width 0.05s linear",
            }}
          />
        </Box>
        <Box display="flex" gap={6}>
          {lista.map((_, i) => (
            <Box
              key={i}
              sx={{
                width: i === indice ? 20 : 6,
                height: 6,
                borderRadius: 999,
                background: i === indice ? "#a78bfa" : "rgba(255,255,255,0.15)",
                transition:
                  "width 0.4s cubic-bezier(.22,1,.36,1), background 0.4s ease",
              }}
            />
          ))}
        </Box>
      </Box>
    </Backdrop>
  );
};

export default LoadingAi;
